module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-room"
  }, [_c('div', {
    staticClass: "user"
  }, [_c('img', {
    staticClass: "user-img",
    attrs: {
      "src": require("../../../assets/image/zhibojian_fanhui@2x.png"),
      "alt": ""
    },
    on: {
      "click": _vm.goBack
    }
  }), _vm._v(" "), (_vm.data && _vm.data.chatRoomDetails) ? _c('div', {
    staticClass: "user-content",
    on: {
      "click": _vm.handleShowZbjl
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.data.chatRoomDetails.backgroundUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user-content-div"
  }, [_c('span', {
    staticClass: "user-content-div-span"
  }, [_vm._v(_vm._s(_vm.data.chatRoomDetails.name))]), _vm._v(" "), _c('span', {
    staticClass: "user-content-div-span1"
  }, [_vm._v("ID：" + _vm._s(_vm.data.chatRoomDetails.thirdId))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-left"
  }, [(_vm.data && _vm.data.chatRoomDetails) ? _c('img', {
    staticClass: "bj",
    attrs: {
      "src": _vm.data.chatRoomDetails.backgroundUrl,
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-left-top"
  }, [(_vm.isZb == 2) ? _c('tengxunyun', {
    ref: "txy"
  }) : _vm._e(), _vm._v(" "), (_vm.isZb == 1) ? _c('div', {
    staticClass: "tengxunyunzb"
  }, [_c('tengxunyunzb', {
    ref: "txyzb"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isZb == 2) ? _c('div', {
    staticClass: "txy-list-btn"
  }, [_c('div', {
    staticClass: "txy-list-btn-item",
    on: {
      "click": _vm.handleUpdateMuted
    }
  }, [(_vm.muted) ? _c('img', {
    attrs: {
      "src": require("../../../assets/image/zhibojian_shengyin_kai@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.muted) ? _c('img', {
    attrs: {
      "src": require("../../../assets/image/zhibojian_shengyin_guan@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.shengyin')))])]), _vm._v(" "), _c('div', {
    staticClass: "txy-list-btn-item",
    on: {
      "click": _vm.handleUpdateSvga
    }
  }, [(_vm.svga) ? _c('img', {
    attrs: {
      "src": require("../../../assets/image/zhibojian_liwutexiao_kai@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.svga) ? _c('img', {
    attrs: {
      "src": require("../../../assets/image/zhibojian_liwutexiao_guan@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.liwutexiao')))])])]) : _vm._e(), _vm._v(" "), (_vm.show_gdlw) ? _c('quanbuliwu', {
    on: {
      "close": function($event) {
        _vm.show_gdlw = false
      },
      "updateUser": _vm.handleUpdateUser
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_gwc) ? _c('gouwuche', {
    on: {
      "close": function($event) {
        _vm.show_gwc = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_kjdy) ? _c('kuaijieduanyu', {
    on: {
      "close_kjdy": function($event) {
        _vm.show_kjdy = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_gly) ? _c('guanliyuan', {
    ref: "gly",
    on: {
      "close_gly": function($event) {
        _vm.show_gly = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_zbjl) ? _c('zhibojilu', {
    on: {
      "close_zbjl": function($event) {
        _vm.show_zbjl = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_gg) ? _c('gongao', {
    on: {
      "close_gg": function($event) {
        _vm.show_gg = false
      },
      "update_gg": _vm.updateGg
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "box-left-bottom"
  }, [(_vm.isZb == 2 && _vm.isShowGift) ? _c('liwu', {
    ref: "liwu",
    on: {
      "show_gdlw": _vm.hanldeShowGdlw
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isZb == 1 || !_vm.isShowGift) ? _c('zhuboshezhi', {
    ref: "zhuboshezhi",
    on: {
      "setVol": _vm.handleSetVol,
      "show_kjdy": _vm.handleShowKjdy,
      "show_gly": _vm.handleShowGly,
      "show_gg": _vm.handleShowGg,
      "show_svga": _vm.hanldeShowSvga
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isZb == 2 && _vm.isShowGift) ? _c('div', {
    staticClass: "gouwuche",
    on: {
      "click": _vm.handleShowGwc
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/image/zhibojian_gouwuche@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.gouwuche')))])]) : _vm._e()], 1), _vm._v(" "), _c('liwudonghua', {
    ref: "lwdh"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "box-right"
  }, [_c('zaixianguanzhong', {
    ref: "zaixian",
    on: {
      "show_user": _vm.handleShowUser
    }
  }), _vm._v(" "), _c('danmu', {
    ref: "danmu",
    on: {
      "addSvgaToQueue": _vm.hanldeAddSvgaToQueue,
      "changeUser": _vm.updateChangeUser,
      "show_user": _vm.handleShowUser,
      "addLwToQueue": _vm.handleAddLwToQueue,
      "pulling": _vm.updatePulling,
      "updataNotice": _vm.handleShowGg
    }
  }), _vm._v(" "), _c('user', {
    ref: "user",
    on: {
      "addAdmin": _vm.handleAddAdmin
    }
  })], 1), _vm._v(" "), _c('guanbizhibo', {
    ref: "gbzb"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a6a89b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/zhibojian/zhibojian.vue
// module id = 959
// module chunks = 1